export interface SiteMetadata {
  siteName: string;
  siteUrl: string;
  locale: string;
  titleTemplate: string;
  defaultTitle: string;
  defaultDescription: string;
  defaultImage: string;
  defaultImageAlt: string;
  defaultKeywords: string[];
  twitterHandle?: string;
}

export const siteMetadata: SiteMetadata = {
  siteName: 'Turbo Labs',
  siteUrl: 'https://turbo.inc',
  locale: 'en_US',
  titleTemplate: '%s | Turbo Labs',
  defaultTitle: 'Turbo Labs | AI-first product partner breaking the SaaS iron triangle',
  defaultDescription:
    'Turbo Labs pairs senior product + engineering pods with agentic automation rails to ship production-grade SaaS in days—speed, scope, and quality without trade-offs.',
  defaultImage: '/assets/COVER.jpg',
  defaultImageAlt: 'Turbo Labs cover showing AI-first product, automation, and agentic systems.',
  defaultKeywords: [
    'Turbo Labs',
    'AI product partner',
    'agentic automation',
    'Rapid SaaS',
    'iron triangle',
  ],
};

export const defaultSEO = {
  titleTemplate: siteMetadata.titleTemplate,
  defaultTitle: siteMetadata.defaultTitle,
  description: siteMetadata.defaultDescription,
  canonical: siteMetadata.siteUrl,
  openGraph: {
    type: 'website',
    locale: siteMetadata.locale,
    url: siteMetadata.siteUrl,
    site_name: siteMetadata.siteName,
    images: [
      {
        url: `${siteMetadata.siteUrl}${siteMetadata.defaultImage}`,
        width: 1200,
        height: 630,
        alt: siteMetadata.defaultImageAlt,
      },
    ],
  },
  ...(siteMetadata.twitterHandle
    ? {
        twitter: {
          handle: siteMetadata.twitterHandle,
          site: siteMetadata.twitterHandle,
          cardType: 'summary_large_image',
        },
      }
    : {}),
  additionalMetaTags: [
    {
      name: 'viewport',
      content: 'viewport-fit=cover, width=device-width, initial-scale=1.0, maximum-scale=1.0',
    },
    {
      name: 'theme-color',
      content: '#18181b',
    },
  ],
};
